import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { Angulartics2 } from "angulartics2";

export interface MessengerListenerInterface {
  displayMessage(level: string, message: string);
}

@Injectable()
export class MessengerService implements ErrorHandler {
  messengerListenerInterface: MessengerListenerInterface;

  constructor(private injector: Injector) {}

  public displayMessage(level: string, message: string) {
    this.messengerListenerInterface.displayMessage(level, message);
  }

  public registerMessengerListener(
    messengerListenerInterface: MessengerListenerInterface
  ) {
    this.messengerListenerInterface = messengerListenerInterface;
  }
  handleError(error) {
    const angulartics2 = this.injector.get(Angulartics2);
    console.error(">>> error message", error.message);
    angulartics2.eventTrack.next({
      action: "Error occured",
      properties: {
        error: error.message,
      },
    });
    if (this.messengerListenerInterface) {
      this.messengerListenerInterface.displayMessage("danger", error.message);
    }
  }
}
